const STORAGE_KEY_PREFIX = 'pvx_play_session_';

const generateSessionId = (): string => {
  return `chromecast_${String(Date.now())}_${Math.random().toString(36).slice(2, 11)}`;
};

const getPlaySessionId = (mediaId: string): string => {
  const storageKey = `${STORAGE_KEY_PREFIX}_${mediaId}`;

  try {
    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      return stored;
    }
  } catch (error) {}

  const newSessionId = generateSessionId();

  try {
    sessionStorage.setItem(storageKey, newSessionId);
  } catch (error) {}

  return newSessionId;
};

export default getPlaySessionId;
